import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";

const EASE = [0.16, 1, 0.3, 1];
const VIEW = { once: true, margin: "-80px" };

export const SECTION_HEADING_CSS = `
.sh-title{font-family:'Playfair Display','Cormorant Garamond',Georgia,serif;font-weight:500;letter-spacing:-0.022em;color:#F5EFE2;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-rendering:optimizeLegibility;font-feature-settings:"kern","liga","lnum"}
.sh-accent{font-style:italic;font-weight:500;background:linear-gradient(100deg,#F6E3A6 0%,#E9CE7A 30%,#D4AF37 55%,#F1DDA4 80%,#E2C268 100%);background-size:220% 100%;-webkit-background-clip:text;background-clip:text;color:transparent;padding-right:0.06em}
.sh-accent--shimmer{animation:shSheen 7s linear infinite}
@keyframes shSheen{0%{background-position:0% 0}100%{background-position:220% 0}}
@media (prefers-reduced-motion: reduce){.sh-accent--shimmer{animation:none}}
`;

// Gold hairline + mono label used above every landing section headline.
export const Eyebrow = ({ children, className = "", testId }) => {
  const { t } = useLang();
  return (
    <motion.p data-testid={testId} className={`flex items-center gap-3 text-[11px] font-mono-lux tracking-[0.3em] uppercase text-[#D4AF37] ${className}`}
      initial={{ opacity: 0, y: 10 }} whileInView={{ opacity: 1, y: 0 }} viewport={VIEW} transition={{ duration: 0.7, ease: EASE }}>
      <motion.span aria-hidden className="h-px w-8 shrink-0 origin-left" style={{ background: "linear-gradient(90deg,#D4AF37,rgba(212,175,55,0.15))" }}
        initial={{ scaleX: 0 }} whileInView={{ scaleX: 1 }} viewport={VIEW} transition={{ duration: 0.9, ease: EASE, delay: 0.1 }} />
      {t(children)}
    </motion.p>
  );
};

// Ivory lead + champagne-gold key phrase, each line rising in softly on scroll.
export const SectionHeading = ({ eyebrow, lead, accent, as = "h2", size = "text-4xl sm:text-5xl lg:text-[3.4rem]", shimmer = false, className = "", testId }) => {
  const { t } = useLang();
  const Tag = motion[as];
  const line = (i) => ({ initial: { opacity: 0, y: 22 }, whileInView: { opacity: 1, y: 0 }, viewport: VIEW, transition: { duration: 0.9, ease: EASE, delay: 0.12 + i * 0.12 } });
  return (
    <div className={className}>
      <style>{SECTION_HEADING_CSS}</style>
      {eyebrow && <Eyebrow className="mb-5">{eyebrow}</Eyebrow>}
      <Tag data-testid={testId} className={`sh-title ${size} leading-[1.08]`}>
        <motion.span className="block" {...line(0)}>{t(lead)}</motion.span>
        {accent && <motion.span className={`block sh-accent ${shimmer ? "sh-accent--shimmer" : ""}`} {...line(1)}>{t(accent)}</motion.span>}
      </Tag>
    </div>
  );
};

export default SectionHeading;
